import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import moment, { Moment } from 'moment';

export const getTimeFromDate = (inputDate: string): string => {
  // Parse the input date string
  const date = new Date(inputDate);

  // Get hours, minutes, and seconds
  const hours: number = date.getHours();
  const minutes: number = date.getMinutes();

  // Convert hours to 12-hour format and determine if it's AM or PM
  const ampm: string = hours >= 12 ? 'pm' : 'am';
  const formattedHours: number = hours % 12 || 12; // Handle midnight (0) as 12

  // Format the time string
  const formattedTime: string = `${formattedHours
    .toString()
    .padStart(2, '0')}.${minutes.toString().padStart(2, '0')} ${ampm}`;
  return formattedTime; // HH.MM am/pm
};

export const formatDateAndTime = (
  inputDate: string | number | undefined | null,
  format?: string
): string | undefined => {
  if (!inputDate) {
    return;
  }
  dayjs.extend(utc);
  const formattedDate = dayjs(inputDate).format(format || 'YYYY-MM-D HH:mm:ss');

  return formattedDate;
};

export const formatDateTimeMonth = (
  inputDate: string | number | Date | undefined | null,
  format?: string
): string | undefined => {
  if (!inputDate) {
    return;
  }

  dayjs.extend(utc);
  const formattedDate = dayjs(inputDate)
    .utc()
    .format(format || 'DD MMM YYYY, h:mm:ssa');

  return formattedDate;
};

export const getDaysDifference = (
  inputDate: string | undefined | null
): number | undefined => {
  if (!inputDate) {
    return;
  }
  dayjs.extend(utc);
  const currentDate = dayjs().utc().startOf('day');
  const targetDate = dayjs(inputDate).utc().startOf('day');
  const differenceInDays = targetDate.diff(currentDate, 'day');
  return Math.abs(differenceInDays);
};

export function formatToISOString(date: Moment | undefined): string {
  // dayjs.extend(utc)
  const formattedDate = moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  return formattedDate;
}

export function getCurrentDateISOString() {
  return moment(moment()).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
}
